<template>
  <!--------------------
   START - Mobile Menu
   -------------------->
  <div class="menu-mobile menu-activated-on-click">
    <div class="mm-logo-buttons-w">


        <router-link class="logo" to="/dashboard/info">
          <img :src="companyLogo" class="mobile-logo"/>
          <span>{{ piniaCurrentUser?.accessRightTranslated }}</span>
        </router-link>

<!--      <router-link to="/dashboard/info">-->
<!--        <img src="@/assets/img/bsg-mobile-logo.png" style="width: 45px; height: 25px;" class="w-100" alt="BSG"/>-->
<!--        <span>{{ piniaCurrentUser?.accessRightTranslated }}</span>-->
<!--      </router-link>-->

      <!--      <a class="mm-logo" href="index.html">-->
      <!--        <img src="../../assets/img/bsg-mobile-logo.png" style="width: 60px; height: 30px;">-->
      <!--        <span>{{ piniaCurrentUser?.accessRightTranslated }}</span>-->
      <!--      </a>-->

      <div class="mm-buttons">
        <div class="content-panel-open">
          <div class="os-icon os-icon-grid-circles"></div>
        </div>
        <div class="mobile-menu-trigger">
          <div class="os-icon os-icon-hamburger-menu-1"></div>
        </div>
      </div>
    </div>

    <div class="menu-and-user">
      <div class="logged-user-w">
        <router-link :to="{ name: 'userProfile' }">
          <div class="logged-user-avatar-info">
            <div class="avatar-w">
              <img alt="" src="../../assets/img/user.jpg">
            </div>
            <div class="logged-user-info-w">
              <div class="logged-user-name">
                {{ piniaCurrentUser.firstName }} {{ piniaCurrentUser.lastName }}
              </div>
              <div class="logged-user-role">
                {{ piniaCurrentUser.userAccessRights }}
              </div>
            </div>
          </div>
        </router-link>
      </div>
      <!--------------------
      START - Mobile Menu List
      -------------------->
      <ul class="main-menu">
        <div v-if="impersonating" class="mb-4 w-100 text-center">
          <button @click="stopImpersonation()" class="btn btn-danger w-100"
                  style="font-size: 13px; text-transform: uppercase">
            Exit impersonation
          </button>
        </div>


        <li v-for="(item) in menu" :class="{ 'has-sub-menu': item.submenu }" :key="item.title">
          <router-link class="text-white text-decoration-none" :to="{ name: item.name }">
            <div class="icon-w">
              <div :class="item.icon"></div>
              <img v-if="item.img" :src="item.img" alt="icon" width="20" height="20"/>
            </div>
            <span>{{ item.title }}</span>
          </router-link>

          <ul v-if="item.submenu" class="sub-menu">
            <li v-for="(subItem) in item.submenu" :key="subItem.title" class="nav-item active py-0">
              <router-link class="nav-link" :to="{ name: subItem.name }">{{ subItem.title }}</router-link>
            </li>
          </ul>
        </li>
        <li class="text-white text-decoration-none">
          <a href="#" @click="handleLogout">
            <div class="icon-w">
              <i class="os-icon os-icon-signs-11"></i>
            </div>
            <span>Logout</span>
          </a>
        </li>
      </ul>
      <!--------------------
      END - Mobile Menu List
      -------------------->
    </div>
  </div>
  <!--------------------
  END - Mobile Menu
  -------------------->
</template>

<script setup>
import securityService from '@/api/Security';
import {CloseToast} from '@/components/VueToast';
import router from '@/router';
import {formatRole} from '@/shared/functions';
import {getMenuLinks} from '@/shared/utils/MenuLinksUtils';
import {piniaUserStore} from '@/store/piniaUserStore';
import $ from 'jquery';
import {computed, onMounted} from 'vue';
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";

const piniaUserState = piniaUserStore();
const piniaCompanySettingsState = piniaCompanySettingsStore()
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const companyLogo = computed(() => piniaCompanySettingsState.companySettings?.logoUrl);
const impersonating = computed(() => piniaUserState.currentUser.impersonating);

const menu = computed(() => {
  const currentUserRoles = piniaCurrentUser.value.roles;

  return getMenuLinks()
      .map(item => {
        const filteredSubmenu = item.submenu?.filter(subItem => {
          return (
              subItem.roles &&
              Array.isArray(subItem.roles) &&
              subItem.roles.some(role => currentUserRoles.includes(role))
          );
        });

        const hasTopLevelAccess =
            item.roles &&
            Array.isArray(item.roles) &&
            item.roles.some(role => currentUserRoles.includes(role));

        if (hasTopLevelAccess || (filteredSubmenu && filteredSubmenu.length)) {
          return {
            ...item,
            submenu: filteredSubmenu,
          };
        }

        return null;
      })
      .filter(item => item !== null);
});

function handleLogout() {
  localStorage.clear();
  window.location.reload();
  router.push({name: 'login'});
}

const stopImpersonation = async () => {
  try {
    const {data} = await securityService.stopImpersonation();
    localStorage.setItem('token', data.data.token);
    await piniaUserState.piniaGetUser();

    await router.push({name: `dashboard-${formatRole(piniaCurrentUser.value.roles[0])}`});
    CloseToast();
  } catch (error) {
    console.error('Failed to stop impersonation:', error);
  }
};

onMounted(async () => {
  $('.mobile-menu-trigger').on('click', function () {
    if (window.innerWidth >= 768) return false;
    $('.menu-mobile .menu-and-user').slideToggle(200, 'swing');
    return false;
  });

  //   var menu_timer;
  // $('.menu-activated-on-hover').on('mouseenter', 'ul.main-menu > li.has-sub-menu', function () {
  //   var $elem = $(this);
  //   clearTimeout(menu_timer);
  //   $elem.closest('ul').addClass('has-active').find('> li').removeClass('active');
  //   $elem.addClass('active');
  // });
  // $('.menu-activated-on-hover').on('mouseleave', 'ul.main-menu > li.has-sub-menu', function () {
  //   var $elem  = $(this);
  //   menu_timer = setTimeout(function () {
  //     $elem.removeClass('active').closest('ul').removeClass('has-active');
  //   }, 30);
  // }); // INIT MENU TO ACTIVATE ON CLICK

  //$('.menu-activated-on-click').on('click', 'li.has-sub-menu > a', function () {

  //$('.menu-mobile .menu-and-user').slideToggle(200, 'swing');
  //return false;
  //});

  $('.menu-activated-on-click').on('click', 'li:not(.has-sub-menu) > a', function () {
    if (window.innerWidth >= 768) return false;
    $('.menu-mobile .menu-and-user').slideToggle(200, 'swing');
    return false;
  });
});
</script>

<style scoped>

</style>